import React, { useEffect, useState } from 'react';

import { SplashScreen as ExpoSplashScreen } from 'expo-router';
import { setStatusBarStyle, setStatusBarTranslucent } from 'expo-status-bar';
import LottieView from 'lottie-react-native';
import { Platform, StyleSheet } from 'react-native';

import logger from 'utils/logger';

import { AppInner } from './AppInner';
import { AnimatedSplashScreen } from './components/splash-screen/splash-screen';

const splashBounceJson = require('./assets/splash-screen.json');

const SPLASH_SCREEN_DURATION = 1800;
const WIGGLE_ROOM = 500;
export const SPLASH_SCREEN_FAILSAFE_TIMEOUT = WIGGLE_ROOM + SPLASH_SCREEN_DURATION;

export const App: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [animatedSplashVisible, setAnimatedSplashVisible] = useState(
    !AnimatedSplashScreen.getHideSplashPreInit()
  );

  useEffect(() => {
    if (Platform.OS === 'web') {
      return; // no splashscreen on web
    }

    ExpoSplashScreen.hideAsync(); // required for deep linking situations

    // very important for android status bar to work properly. (settings elsewhere do not work properly) do not change without testing!
    Platform.OS === 'android' && setStatusBarTranslucent(true);
    setStatusBarStyle('dark');

    // FAILSAFE - make sure all splash screens hide if something goes bad
    setTimeout(() => {
      setAnimatedSplashVisible(oldVal => {
        if (oldVal) {
          logger.warn({
            message: `Hiding splash screen took longer than ${SPLASH_SCREEN_FAILSAFE_TIMEOUT}ms. This SHOULD NOT happen and should be investigated but it has been forced to work for this session.`,
          });
          return false;
        }
        return oldVal;
      });
    }, SPLASH_SCREEN_FAILSAFE_TIMEOUT);
  }, []);

  return (
    <>
      <AppInner routes={children} />
      {animatedSplashVisible && (
        <LottieView
          resizeMode="cover"
          hardwareAccelerationAndroid
          autoPlay
          source={splashBounceJson}
          style={styles.lottieView}
          loop={false}
          onAnimationFinish={() => {
            setAnimatedSplashVisible(false);
          }}
          onAnimationFailure={err => {
            setAnimatedSplashVisible(false);
          }}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  lottieView: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});
